export default {
  title: 'Templates',

  labels: {
    id: 'ID',
    title: 'Title',
    type: 'Type',
    owner: 'Owner',
    text: 'Text',
    isActive: 'Active'
  },

  buttons: {
    create: 'Create template',
    apply: 'Apply'
  },
  links: { edit: 'Change template' },
  dialogs: { create: 'Name your template' },

  contents: {
    confirm: {
      remove: 'Are you sure you want to delete the template {title}?'
    }
  },

  hints: {
    sendername: 'Sender name: {sendername}',
    text: 'Text: {text}'
  },

  tooltips: {
    isActive: 'Activate or deactivate a template.',
    type: 'Type: {type}',
    sender: 'Sender name: {sender}',
    text: 'Text: {text}'
  },

  snackbars: {
    created: 'Template successfully created.',
    updated: 'Template successfully updated.',
    removed: 'Template successfully removed.'
  }
}
